import { render, staticRenderFns } from "./Addresslist.vue?vue&type=template&id=0ef7078f&scoped=true"
import script from "./Addresslist.vue?vue&type=script&lang=js"
export * from "./Addresslist.vue?vue&type=script&lang=js"
import style0 from "./Addresslist.vue?vue&type=style&index=0&id=0ef7078f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7078f",
  null
  
)

export default component.exports